import { subMonths } from "date-fns";
import { ChannelModel } from "../../channel/models/ChannelModel";
import { StoreModel } from "../../store/models/StoreModel";

export class ReportGeneratorFilterModel {
	stores: number[] = [];
	storeListWrapper: StoreModel[] = [];
	channels: number[] = [];
	channelListWrapper: ChannelModel[] = [];
	dateStart: Date = subMonths(new Date(), 1);
	dateEnd: Date = new Date();

	normalize():any {
		return {
			stores: (this.storeListWrapper || []).map((s) => s.id),
			channels: (this.channelListWrapper || []).map((c) => c.id),
			dateStart: this.dateStart ? this.dateStart.toISOString() : undefined,
			dateEnd: this.dateEnd ? this.dateEnd.toISOString() : undefined,
		}
	}
}
